import { render, staticRenderFns } from "./Descontos.vue?vue&type=template&id=e246d31e"
import script from "./Descontos.vue?vue&type=script&lang=js"
export * from "./Descontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports